// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1a5bq","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__rnn1T"};